import { Box, InputLabel, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { OTHER_INCOME_STRUCTURE_ID } from 'src/Enum/IncomeStructure';
import { useIncomeStructure } from '../IncomeStructureProvider/IncomeStructureProvider';
import { findMasterDataById } from '../utils';
import ProductIncomeYearFieldsForm from './ProductIncomeYearFieldsForm';

const ProductIncomeOtherForm = () => {
  const { productIncome } = useIncomeStructure();

  const otherProductIncome = findMasterDataById(
    productIncome,
    OTHER_INCOME_STRUCTURE_ID.OTHER_PRODUCT_INCOME
  );

  return (
    <>
      {otherProductIncome && (
        <Flex width={1} mt={2} alignItems={'center'}>
          <Box width={1} minWidth={235} maxWidth={350}>
            <InputLabel sx={{ textAlign: 'right' }}>
              {otherProductIncome.nameTh}
            </InputLabel>
            <Typography textAlign={'right'} color={'text.secondary'}>
              (พันบาท)
            </Typography>
          </Box>
          <ProductIncomeYearFieldsForm
            keyItem={otherProductIncome.id.toString()}
          />
        </Flex>
      )}
    </>
  );
};

export default ProductIncomeOtherForm;
